import { IControlViewModel, ICardModel, ICardUIExtensionContext, CardUIExtension } from "tessa/ui/cards";
import { DotNetType, createTypedField, Visibility, Guid } from "tessa/platform";
import { CdCardTypes } from 'src/cdScripts/Helpers/CdCardTypes';
import { Card, CardRow, CardSection } from 'tessa/cards';
import { PkCommonHelper } from "src/pkScripts/Helpers/PkCommonHelper";
import { ValidationResultType } from "tessa/platform/validation";
import { CdDocStates } from "src/cdScripts/Helpers/CdDocStates";
import { CardRequest, CardService } from "tessa/cards/service";
import { CdRequestTypes } from "src/cdScripts/Helpers/CdRequestTypes";
import { showNotEmpty } from "tessa/ui";

export class CdGlazingOrderUIExtension extends CardUIExtension {

    private _disposer: Function | null = null;

    public async initialized(context: ICardUIExtensionContext) {
        let model: ICardModel;
        let card: Card;
        if ((model = context.model) == null || (card = context.model.card) == null) {
            return;
        }

        if (!Guid.equals(card.typeId, CdCardTypes.PkGlazingOrderTypeID)) {
            return;
        }

        // Установим доступ к элементам в зависимости от текущего состояния карточки
        this.LockControlsAccordingCurrentState(model, card);

        // Обработка флага "РД отсутствует в архиве"
        this.HandleMissingTechnicalDocumentationFlag(model, card);

        // Заполнение таблицы "Работы выполнены по проектной документации" при выборе тех.документа из представления
        await this.WorksByProjectDocumentationTableFilling(card);

        // Обработка "вида заявки на остеклкение".
        this.HandleOrderKind(model, card);

        // Обработка флага "Наличие спец. работ"
        this.HandleSpecialWorkFlag(model, card);

        // Обработка элемента управления "Вариант исполнителя"
        this.HandlePerformerType(model, card);
    }

    public async saving(context: ICardUIExtensionContext) {
        let card: Card;
        if ((card = context.model.card) == null) {
            return;
        }
        if (!Guid.equals(context.model.card.typeId, CdCardTypes.PkGlazingOrderTypeID)) {
            return;
        }

        // Обработка "вида заявки на остеклкение".
        // Если выбран вариант "доп. соглашение", то поле "Номер основного договора"  д.б. заполнено.
        let goSection: CardSection | undefined = card.sections.tryGet("PkGlazingOrder");
        let mainContractNumber: string | undefined = goSection!.fields.get("MainContractNumber");
        let orderKindID: number | undefined = goSection!.fields.get('OrderKindID');
        if (orderKindID === 1 && PkCommonHelper.IsNullOrWhitespace(mainContractNumber))//  доп. соглашение и нет номера основного договора
        {
            context.validationResult.add(ValidationResultType.Error, "Необходимо заполнить поле 'Номер основного договора'.");
        }
    }


    private SetAllControlsReadOnlyState(model: ICardModel, isReadOnly: boolean) {
        model.controls.forEach(control => {
            control.isReadOnly = isReadOnly;
        });
    }

    private SetControlReadOnlyState(model: ICardModel, controlName: string, isReadOnly: boolean) {
        const control = model.controls.get(controlName);
        if (control != null) {
            control.isReadOnly = isReadOnly;
        }
    }

    /** Обновить видимость контролов работ */
    private UpdateWorkControlsVisability(missingTechnicalDocumentation: boolean | undefined, workTextControl: IControlViewModel, workRefControl: IControlViewModel) {
        if (missingTechnicalDocumentation !== undefined && missingTechnicalDocumentation)
            this.UpdateControlsVisability(workTextControl, workRefControl);
        else
            this.UpdateControlsVisability(workRefControl, workTextControl);
    }

    /** Включает первый контрол и выключает второй */
    private UpdateControlsVisability(firstControl: IControlViewModel, secondControl: IControlViewModel) {
        if (firstControl.controlVisibility !== Visibility.Visible)
            firstControl.controlVisibility = Visibility.Visible;
        if (secondControl.controlVisibility !== Visibility.Collapsed)
            secondControl.controlVisibility = Visibility.Collapsed;
    }


    /* Устанавливает доступ к элементам в зависимости от текущего состояния карточки */
    private LockControlsAccordingCurrentState(model: ICardModel, card: Card) {
        // Если состояние карточки "Черновик" или "На доработке" блокируем некоторые эл-ты управления
        let pdciSection: CardSection | undefined = card.sections.tryGet('PkDocumentCommonInfo');
        if (pdciSection) {
            let stateID: number | null | undefined = pdciSection.fields.tryGet('StateID');
            if (stateID && (stateID === CdDocStates.Draft.id || stateID === CdDocStates.Rework.id)) {
                this.SetControlReadOnlyState(model, "Department", true);
                this.SetControlReadOnlyState(model, "IsSpecialWork", true);
                this.SetControlReadOnlyState(model, "PlannedPerformanceDate", true);
                this.SetControlReadOnlyState(model, "PlannedCompletionDate", true);
                this.SetControlReadOnlyState(model, "PerformerType", true);
                this.SetControlReadOnlyState(model, "CostOfWork", true);
                this.SetControlReadOnlyState(model, "EsudAgreement", true);
            }
            else {
                // если нет ни одной задачи, то блокируем все поля
                if (card.tasks.length === 0) {
                    this.SetAllControlsReadOnlyState(model, true);
                }
            }
        }
    }

    //* Обработка флага "РД отсутствует в архиве" */
    private HandleMissingTechnicalDocumentationFlag(model: ICardModel, card: Card) {
        let goSection = card.sections.tryGet('PkGlazingOrder');
        let workTextControl: IControlViewModel | undefined = model.controls.get('WorkTextControl');
        let workRefControl: IControlViewModel | undefined = model.controls.get('WorkRefControl');
        if (workTextControl && workRefControl && goSection) {
            let missingTechnicalDocumentation: boolean | undefined = goSection.fields.tryGet('MissingTechnicalDocumentation');
            this.UpdateWorkControlsVisability(missingTechnicalDocumentation, workTextControl, workRefControl);

            goSection.fields.fieldChanged.add(e => {
                if (e.fieldName === 'MissingTechnicalDocumentation') {
                    missingTechnicalDocumentation = e.fieldValue;
                    if (workTextControl && workRefControl)
                        this.UpdateWorkControlsVisability(missingTechnicalDocumentation, workTextControl, workRefControl);
                }
            });
        }
    }

    //* Заполнение таблицы "Работы выполнены по проектной документации" при выборе тех.документа из представления */
    private async WorksByProjectDocumentationTableFilling(card: Card) {
        let wpdSection = card.sections.tryGet('PkGlazingOrderWorksByProjectDocumentation');
        if (!wpdSection) { return; }

        wpdSection.rows.collectionChanged.add(e => {
            if (e.added.length > 0) {
                let row: CardRow = e.added[0];
                row.fieldChanged.add(async e1 => {
                    if (e1.fieldName === 'WorkTechnicalDocumentationID') {
                        let tdId = e1.fieldValue;
                        if (!tdId) {
                            row.set('Number', createTypedField(null, DotNetType.String));
                            row.set('RdDivision', createTypedField(null, DotNetType.String));
                            row.set('ContractDivision', createTypedField(null, DotNetType.String));
                            row.set('Version', createTypedField(null, DotNetType.String));
                            return;
                        }

                        const request = new CardRequest();
                        request.requestType = CdRequestTypes.GetRdInfo;
                        request.info["CardID"] = createTypedField(tdId, DotNetType.Guid);

                        const response = await CardService.instance.request(request);
                        await showNotEmpty(response.validationResult.build());
                        if (!response.validationResult.isSuccessful) {
                            return null;
                        }

                        let docNumber = row.tryGetField('WorkTechnicalDocumentationFullNumber');
                        let respInfo = response.info;
                        if (respInfo && respInfo.ArNumber && respInfo.ArNumber.$value)
                            row.set('Number', createTypedField(respInfo.ArNumber.$value, DotNetType.String));
                        else if (docNumber)
                            row.set('Number', createTypedField(docNumber.$value, DotNetType.String));

                        if (respInfo && respInfo.RdDivision && respInfo.ContractDivision && respInfo.Version) {
                            row.set('RdDivision', createTypedField(respInfo.RdDivision.$value, DotNetType.String));
                            row.set('ContractDivision', createTypedField(respInfo.ContractDivision.$value, DotNetType.String));
                            row.set('Version', createTypedField(respInfo.Version.$value, DotNetType.String));
                        }
                    }
                });
            }
        });
    }

    //* Обработка "вида заявки на остеклкение". */
    private HandleOrderKind(model: ICardModel, card: Card) {

        // Если выбран вариант "доп. соглашение", то поле "Номер основного договора" должно отображаться и д.б. заполнено.
        // Если выбран вариант "новый договор",  то поле "Номер основного договора" скрыто и не проверяется.
        let goSection: CardSection | undefined = card.sections.tryGet("PkGlazingOrder");
        let orderKindID: number | undefined = goSection!.fields.get('OrderKindID');

        let mainContractNumberControl: IControlViewModel | undefined = model.controls.get('MainContractNumber');

        if (!mainContractNumberControl) {
            return;
        }

        mainContractNumberControl!.controlVisibility = ((orderKindID ? true : false) && (orderKindID === 1)) ? Visibility.Visible : Visibility.Collapsed;

        // скрываем/показываем поле "Номер осн. договора" в зависимости от варианта в поле "доп. соглашение"
        goSection!.fields.fieldChanged.add(async e => {
            if (e.fieldName === "OrderKindID") {
                let selectedOrderKindID = e.fieldValue as number | null | undefined;
                mainContractNumberControl!.controlVisibility = ((selectedOrderKindID ? true : false) && (selectedOrderKindID === 1)) ? Visibility.Visible : Visibility.Collapsed;

            }
        });
    }
  
    //*Обработка флага "Наличие спец. работ" */
    private HandleSpecialWorkFlag(model: ICardModel, card: Card) {
        /// При выставленном флаге должно отображаться поле "Субподрядчик на спец. работы"
        /// Если выбран вариант "собственные силы", то должно отображаться поле "Структурное подразделение", а поле "Субподрядчик на основные работы" скрыто  
        /// Если выбран вариант "субподряд", то должно отображаться поле "Субподрядчик на основные работы", а поле "Структурное подразделение" скрыто 
        
        let goSection: CardSection | undefined = card.sections.tryGet("PkGlazingOrder");
        let isSpecialWork: boolean | undefined = goSection!.fields.get('IsSpecialWork');

        let isSpecialWorkControl: IControlViewModel | undefined = model.controls.get('IsSpecialWork');
        let specialWorkSubContractorControl: IControlViewModel | undefined = model.controls.get('SpecialWorkSubContractor');
       
        if (!isSpecialWorkControl || !specialWorkSubContractorControl) {
            return;
        }
       
        specialWorkSubContractorControl!.controlVisibility = ((isSpecialWork ? true : false) && (isSpecialWork === true)) ? Visibility.Visible : Visibility.Collapsed;

        // скрываем/показываем поле "Номер осн. договора" в зависимости от варианта в поле "доп. соглашение"
        goSection!.fields.fieldChanged.add(async e => {
            if (e.fieldName === "IsSpecialWork") {
                specialWorkSubContractorControl!.controlVisibility = (e.fieldValue as boolean === true) ? Visibility.Visible : Visibility.Collapsed;
            }
        });
    }
   


    //* Обработка элемента управления "Вариант исполнителя" */
    private HandlePerformerType(model: ICardModel, card: Card) {
        ///  При выставленном флаге должно отображаться поле "Субподрядчик на спец. работы"
        ///  Если выбран вариант "собственные силы", то должно отображаться поле "Структурное подразделение", а поле "Субподрядчик на основные работы" скрыто  
        ///  Если выбран вариант "субподряд", то должно отображаться поле "Субподрядчик на основные работы", а поле "Структурное подразделение" скрыто
        let goSection: CardSection | undefined = card.sections.tryGet("PkGlazingOrder");
        let performerTypeID: number | undefined = goSection!.fields.get('PerformerTypeID');

        let performerTypeControl: IControlViewModel | undefined = model.controls.get('PerformerType');
        let innerContractorControl: IControlViewModel | undefined = model.controls.get('InnerContractor');
        let mainWorkSubContractorControl: IControlViewModel | undefined = model.controls.get('MainWorkSubContractor');
    
        if (!performerTypeControl || !innerContractorControl|| !mainWorkSubContractorControl) {
            return;
        }

        //performerTypeID  
        // PkGlazingOrderPerformerType.InnerResources = 0
        // PkGlazingOrderPerformerType.SubContracting = 1
        innerContractorControl!.controlVisibility = ((performerTypeID ? true : false) && (performerTypeID === 0)) ?  Visibility.Visible :  Visibility.Collapsed;
        mainWorkSubContractorControl!.controlVisibility = ((performerTypeID ? true : false) && (performerTypeID === 1))? Visibility.Visible :  Visibility.Collapsed;


        // скрываем/показываем эл-ты управления 
        goSection!.fields.fieldChanged.add(async e => {
            if (e.fieldName === "PerformerTypeID") {
                innerContractorControl!.controlVisibility = (e.fieldValue as number === 0) ? Visibility.Visible : Visibility.Collapsed;
                mainWorkSubContractorControl!.controlVisibility = (e.fieldValue as number === 1) ? Visibility.Visible : Visibility.Collapsed;
            }
        });
 
    }
 

    public finalized() {
        // подчищаем за собой
        if (this._disposer) {
            this._disposer();
            this._disposer = null;
        }
    }
}